<wbo-edit-page #editPage [title]="data.name">
    <fui-formation-group class="basic-group no-header">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name" [(ngModel)]="data.name">
                            </wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control
                                formControlName="discontinued"
                                [(ngModel)]="data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                    <fui-column formGroupName="mixAndMatch">
                        <wbo-mix-and-match-single-select-edit-control
                            formControlName="id" [objectValue]="data.mixAndMatch"
                            [allowClearSelectionOption]="false"
                            [readonly]="mixAndMatchLocked"
                            [(ngModel)]="data.mixAndMatch.id"></wbo-mix-and-match-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-terminal-multi-select-edit-control formControlName="terminals"
                                                                [(ngModel)]="data.terminals"
                                                                [multiObjectValueType]="true">
                        </wbo-terminal-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group [title]="'wbo.mix-and-match-schedule.edit.formation.schedule'">
        <wbo-pricing-schedule-edit></wbo-pricing-schedule-edit>
    </fui-formation-group>
</wbo-edit-page>
